import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { changePlan } from 'api/jalapeno';
import { ACCOUNT_QUERY_KEY } from 'api/queries/useAccountQuery';
import { SUBSCRIPTION_QUERY_KEY } from 'api/queries/useSubscriptionQuery';
import { plansV1Options } from 'data/subscriptionData';
import TaxesApply from 'features/account/my-plan/TaxesApply';
import Button from 'honeydew/Button';
import { Divider } from 'honeydew/Divider';

const planSelectorClasses = 'border rounded-full border-2 cursor-pointer py-10 w-[140px] md:w-[150px] text-center';

function EditPlansV1Module({ account, setError, setIsEditing }) {
    const queryClient = useQueryClient();
    const [planValue, setPlanValue] = useState(account.planID);

    const savePlanID = async () => {
        if (account.planID === planValue) {
            setIsEditing(false);
            return;
        }

        try {
            const response = await changePlan(account.subID, { planID: planValue });
            if (response.msg === 'Success') {
                queryClient.invalidateQueries({ queryKey: [ACCOUNT_QUERY_KEY] });
                queryClient.invalidateQueries({ queryKey: [SUBSCRIPTION_QUERY_KEY] });
                setIsEditing(false);
                setError('');
            } else {
                setError('Unable to update plan');
            }
        } catch {
            setError('Unable to update plan');
        }
    };
    return (
        <div>
            <h4 className="text-body-md font-grotesk-bold">Plan Range</h4>

            <p className="text-body-sm mt-5">
                Select the amount of groceries you would us to pre-fill your cart with each week.
            </p>

            <div className="text-body-sm mb-10 mt-20 flex gap-20">
                {plansV1Options.map((plan) => (
                    <label
                        key={plan.id}
                        htmlFor={plan.id}
                        className={clsx(planSelectorClasses, {
                            'bg-brand-secondary border-kale if:border-beet': planValue === plan.id,
                        })}
                    >
                        <p className="font-grotesk-bold">{plan.planRange}</p>
                        <input
                            className="sr-only"
                            type="radio"
                            id={plan.id}
                            name={plan.id}
                            value={plan.id}
                            checked={planValue === plan.id}
                            onChange={() => setPlanValue(plan.id)}
                        />
                    </label>
                ))}
            </div>

            <TaxesApply />

            <Divider />

            <div className="mt-25 max-w-[350px]">
                <Button id="savePlanSize" size="md" disabled={account.planID === planValue} onClick={savePlanID}>
                    Update
                </Button>
                <button
                    type="button"
                    onClick={() => setIsEditing(false)}
                    className="text-body-sm link mx-auto mt-15 block"
                >
                    Cancel
                </button>
            </div>
        </div>
    );
}

EditPlansV1Module.propType = {
    account: PropTypes.shape({}),
    setError: PropTypes.func.isRequired,
    setIsEditing: PropTypes.func.isRequired,
};

EditPlansV1Module.defaultProps = {
    account: {},
};

export default EditPlansV1Module;
